import React from 'react';
import PropTypes from 'prop-types';
import ShapeSwatchPicker from './ShapeSwatchPicker.jsx';
import FieldErrors, { fieldClass } from './FieldErrors.jsx';

class ShapesTab extends React.Component {
  render() {
    const {
      style, patchStyle, moduleShapes, eyeFrameShapes, eyeBallShapes, swatches, errors,
    } = this.props;
    return (
      <div className="qr-shapes-tab">
        <div className={fieldClass(errors, 'module_shape')}>
          <label className="qr-label">Body dots</label>
          <ShapeSwatchPicker options={moduleShapes} swatches={swatches.module_shape} value={style.module_shape} onChange={(v) => patchStyle('module_shape', v)} />
          <FieldErrors messages={errors.module_shape} />
        </div>
        <div className={fieldClass(errors, 'eye_frame_shape')}>
          <label className="qr-label">Eye frame</label>
          <ShapeSwatchPicker options={eyeFrameShapes} swatches={swatches.eye_frame_shape} value={style.eye_frame_shape} onChange={(v) => patchStyle('eye_frame_shape', v)} />
          <FieldErrors messages={errors.eye_frame_shape} />
        </div>
        <div className={fieldClass(errors, 'eye_ball_shape', 'qr-field--last')}>
          <label className="qr-label">Eye ball</label>
          <ShapeSwatchPicker options={eyeBallShapes} swatches={swatches.eye_ball_shape} value={style.eye_ball_shape} onChange={(v) => patchStyle('eye_ball_shape', v)} />
          <FieldErrors messages={errors.eye_ball_shape} />
        </div>
      </div>
    );
  }
}

ShapesTab.propTypes = {
  style: PropTypes.object.isRequired,
  patchStyle: PropTypes.func.isRequired,
  moduleShapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  eyeFrameShapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  eyeBallShapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  swatches: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

ShapesTab.defaultProps = { errors: {} };

export default ShapesTab;
